/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import ErrorIcon from "../../../components/icons/ErrorIcon";
import messages from "../../../helpers/messages";

function ErrorMessage() {
  return (
    <>
      <ErrorIcon
        height="20px"
        width="20px"
        fill="#B00020"
        className="pos-relative"
        style={{ top: "-3px" }}
      />
      <span className="text-rfq-red pl-8 align-top" data-testid="error-message">
        {messages.unableToPerformActionMessage.defaultMessage}
      </span>
    </>
  );
}

export default ErrorMessage;
